module.exports = __webpack_public_path__ + "img/doctora.7d069a10.png";